var _div;
import { useLiveSessionsTranslation } from "../../hooks/useLiveSessionsTranslation";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var EmptySearch = function EmptySearch(_ref) {
  var searchFilter = _ref.searchFilter;
  var _useLiveSessionsTrans = useLiveSessionsTranslation(),
    t = _useLiveSessionsTrans.t;
  return /*#__PURE__*/_jsxs("div", {
    className: "tw-flex tw-flex-col tw-items-center tw-gap-2 tw-justify-center tw-h-[420px] tw-rounded-[20px] tw-bg-neutral-light-100 dark:tw-bg-elevation-dark-02",
    children: [_div || (_div = /*#__PURE__*/_jsxs("div", {
      className: "tw-w-[140px] tw-h-[140px] tw-bg-neutral-light-300 tw-rounded-full tw-flex tw-flex-col tw-justify-center tw-items-center tw-gap-0.8",
      children: [/*#__PURE__*/_jsxs("div", {
        className: "tw-w-[172px] tw-h-4.4 tw-bg-neutral-light-100 tw-shadow-01 tw-rounded-0.8 tw-px-0.8 tw-py-0.4 tw-flex tw-gap-0.8 tw-items-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "tw-w-5.6 tw-h-full tw-bg-neutral-light-400 tw-rounded-[6px]"
        }), /*#__PURE__*/_jsxs("div", {
          className: "tw-space-y-0.4",
          children: [/*#__PURE__*/_jsx("div", {
            className: "tw-bg-neutral-light-400 tw-rounded tw-w-3.6 tw-h-[6px]"
          }), /*#__PURE__*/_jsx("div", {
            className: "tw-bg-neutral-light-400 tw-rounded tw-w-6.4 tw-h-[6px]"
          })]
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "tw-w-[172px] tw-h-4.4 tw-bg-neutral-light-100 tw-shadow-01 tw-rounded-0.8 tw-px-0.8 tw-py-0.4 tw-flex tw-gap-0.8 tw-items-center",
        children: [/*#__PURE__*/_jsx("div", {
          className: "tw-w-5.6 tw-h-full tw-bg-neutral-light-400 tw-rounded-[6px]"
        }), /*#__PURE__*/_jsxs("div", {
          className: "tw-space-y-0.4",
          children: [/*#__PURE__*/_jsx("div", {
            className: "tw-bg-neutral-light-400 tw-rounded tw-w-3.6 tw-h-[6px]"
          }), /*#__PURE__*/_jsx("div", {
            className: "tw-bg-neutral-light-400 tw-rounded tw-w-6.4 tw-h-[6px]"
          })]
        })]
      })]
    })), /*#__PURE__*/_jsxs("div", {
      className: "tw-w-[325px]",
      children: [/*#__PURE__*/_jsx("h3", {
        className: "tw-font-subtitle5 tw-text-center dark:tw-text-neutral-light-100",
        children: t('NO_RESULTS_FOUND')
      }), /*#__PURE__*/_jsxs("p", {
        className: "tw-font-subtitle5 tw-text-primary-light-500 dark:tw-text-secondary-dark-500 tw-text-center",
        children: ["\u201C", searchFilter, "\u201C"]
      })]
    })]
  });
};